<style type="text/css" lang="scss">
    @import '../../../../static/css/reset.scss';

    #ssoHeaderBig {
    	width:100%;
    	height: 70px;
        #ssoHeaderSma{
            width:1120px;
            height:100%;
            margin:0 auto;
            .logo{
                display:inline-block;
                width:293px;
                height:32px;
                margin-top:18px;
                float:left;
                margin-right:20px;
                background-image: url('./images/logo.png');
                background-size: 100% 100%;
                cursor:pointer;
            }
            .logo_item{
                display: inline-block;
                float: right;
                padding-right: 13px;
                height: 100%;
                .navSpan{
                    display:inline-block;
                    height:100%;
                    a{
                        display:inline-block;
                        width: 55px;
                        height: 39px;
                        font-size:16px;
                        line-height:16px;
                        text-align:center;
                        color:#fff;
                        opacity: 0.6;
                        margin:0 8px;
                        margin-top:31px;
                        &:hover{
                            color: #D2D8EC;
                            border-bottom: 3px solid white;
                        }
                    }

                }
            }

            .userBox{
                display:inline-block;
                float: right;
                .noLogin{
                    display:inline-block;
                    width:70px;
                    height:28px;
                    line-height:28px;
                    text-align:center;
                    font-size:14px;
                    margin-top:27px;
                    cursor:pointer;
                    a{
                        display:block;
                        width:100%;
                        height:100%;
                    }
                    &.login{
                        margin-left: 39px;
                        a{
                            color:rgba(255, 255, 255, 0.6);
                            border: 1px solid rgba(255, 255, 255, 0.4);
                            &:hover{
                                border: 1px solid #D2D8EC;
                            }
                        }
                    }
                    &.register{
                        margin-left: 27px;
                        a{
                            background: #5c78aa;
                            color: rgba(255, 255, 255, 0.9);
                            &:hover{
                                background:  #455A9A;
                            }
                        }

                    }
                }
            }
            .logo_line{
                float: right;
                width: 2px;
                height: 70px;
                display: inline-block;
                background: #fff;
                opacity:0.16;
            }
        }
    }

</style>

<template>
	<div id="ssoHeaderBig">
		<div id="ssoHeaderSma">
            <span class="logo" v-on:click="toIndex"></span>
            <span class="userBox">
                <span class="noLogin login">
                    <router-link to="/login">登录</router-link>
                </span>
                <span class="noLogin register">
                    <router-link to="/register">注册</router-link>
                </span>
            </span>
            <span class="logo_line"></span>
            <span class="logo_item">
                <span class="navSpan" v-for="(el,index) in nav">
                    <a :href="el.url">{{el.name}}</a>
                </span>
            </span>
		</div>
	</div>
</template>

<script>

    module.exports = Vue.component('sso-header',{
    	data:function(){
    		return {
    			nav:window.PAGE_DATA.commonData.nav || [],
    		}
    	},
    	methods:{
    	    toIndex:function(){
    	        window.open("http://www.forex.com.cn");
    	    }
    	}
    })

</script>



// WEBPACK FOOTER //
// src/components/sso/components/header/header.vue